// @ts-check

import '../jsdoc-types';
import {Typography} from '@bonprix/design-system';
import {useMemo} from 'react';
import {rewriteAssetUrl} from '@service/scripts/components/helpers.jsx';

/**
 * @param {Object} props
 * @param {ImageTeaserEntry} props.cdaEntry
 */
export function ImageTeaser({cdaEntry}) {
    const textColor = cdaEntry.fields.textColor || 'white';

    const imageUrl = useMemo(() => {
        const url = new URL(rewriteAssetUrl(cdaEntry.fields.image?.fields.file.url));
        url.searchParams.set('w', '480');
        url.searchParams.set('fit', 'fill');

        return url.toString();
    }, [cdaEntry.fields.image?.fields.file.url]);

    const imageUrls = useMemo(() => {
        /**
         * @type {string[]}
         */
        const urls = [];
        const sizes = ['480', '856', '1920'];
        sizes.forEach((size) => {
            const url = new URL(rewriteAssetUrl(cdaEntry.fields.image?.fields.file.url));
            url.searchParams.set('w', size);
            url.searchParams.set('fit', 'fill');
            urls.push(url.toString() + ' ' + size + 'w');
        });

        return urls;
    }, [cdaEntry.fields.image?.fields.file.url]);

    return (
        <div className="service-page-image-teaser">
            <img src={imageUrl} alt={cdaEntry.fields.image?.fields.description} srcSet={imageUrls.join(',')} sizes="(max-width: 768px) calc(100vw - 20px), (max-width: 1200px) calc((100vw - 32px) * 0.75 - 20px), 856px" width="480" />

            <div
                className="service-page-image-teaser__text"
                style={{
                    color: textColor,
                }}
            >
                <Typography variant="bonprix-h1" component={cdaEntry.fields.isH1 ? 'h1' : 'p'}>
                    {cdaEntry.fields.text}
                </Typography>
            </div>
        </div>
    );
}
